export default {
  state: () => ({
    username: "",
    unitName: "",
    isManager: false,
  }),
  mutations: {
    setUser(state, item) {
      state.username = item.username;
      state.unitName = item.unit_name;
      state.isManager = item.is_manager;
    },
  },
};
